<template>
  <div class="life-navbar">
    <div class="life-navbar-box">
      <img src="../../static/images/lifePay/navbar_bg.png"
      class="life-navbar-bg" />
      <div class="life-navbar-info">
        <div class="navbar-info">
          <div class="life-navbar-back flex_center" @click="$router.back()">
            <img src="../../static/images/lifePay/back.png" />
          </div>
          <div class="life-navbar-title">{{title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less" scoped>
  .life-navbar {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    // z-index: 9999;
    z-index: 999;
    max-width: 750px;
    margin: auto;

    .life-navbar-box {
      width: 100%;
      height: 100%;
      position: relative;

      .life-navbar-info {
        position: absolute;
        width: 100%;
        right: 0;
        bottom: 45px;
        padding: 0 30px;

        .navbar-info {
          position: relative;

          .life-navbar-back {
            width: 30px;
            height: 30px;
            // width: 36px;
            // height: 36px;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;

            img {
              width: 8px;
              height: auto;
            }
          }

          .life-navbar-title {
            font-size: 24px;
            color: #fff;
            font-weight: 900;
            letter-spacing: 2px;
            margin: auto;
            line-height: 36px;
          }
        }
      }

      .life-navbar-bg {
        width: 100%;
        height: 146px;
        object-fit: cover;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/life-topBar.vue